"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// this file is generated via /scripts/create-icons-index-ts.sh
__export(require("./AcademyIcon"));
__export(require("./AcrobatIcon"));
__export(require("./AirplaneIcon"));
__export(require("./AlarmClockIcon"));
__export(require("./AlertIcon"));
__export(require("./AmbulanceIcon"));
__export(require("./AnalysisCoupleIcon"));
__export(require("./AnalysisFamilyIcon"));
__export(require("./AnalysisSingleIcon"));
__export(require("./AnalysisSingleParentIcon"));
__export(require("./ApartmentBuildingIcon"));
__export(require("./AppleIcon"));
__export(require("./ArrowDownIcon"));
__export(require("./ArrowLeftIcon"));
__export(require("./ArrowRightIcon"));
__export(require("./ArrowUpIcon"));
__export(require("./AsteriskIcon"));
__export(require("./AtomIcon"));
__export(require("./AwardIcon"));
__export(require("./BadgeIcon"));
__export(require("./BarchartsIcon"));
__export(require("./BasketIcon"));
__export(require("./BedIcon"));
__export(require("./BedSingleIcon"));
__export(require("./BeerIcon"));
__export(require("./BicycleIcon"));
__export(require("./BirthdayCakeIcon"));
__export(require("./BlastIcon"));
__export(require("./BlogIcon"));
__export(require("./BlueLightIcon"));
__export(require("./BoatIcon"));
__export(require("./BoneIcon"));
__export(require("./BookIcon"));
__export(require("./BookmarkIcon"));
__export(require("./BoxBlastIcon"));
__export(require("./BrokenArmIcon"));
__export(require("./BrokenArmStarIcon"));
__export(require("./BrokenLegIcon"));
__export(require("./BulletIcon"));
__export(require("./BurgerMenuIcon"));
__export(require("./BusinessCardIcon"));
__export(require("./CalculatorIcon"));
__export(require("./CalendarDateIcon"));
__export(require("./CalendarIcon"));
__export(require("./CallBackIcon"));
__export(require("./CameraIcon"));
__export(require("./CamperIcon"));
__export(require("./CandleIcon"));
__export(require("./CapitolIcon"));
__export(require("./CaravanIcon"));
__export(require("./CarDamageIcon"));
__export(require("./CareerIcon"));
__export(require("./CaretDownIcon"));
__export(require("./CaretUpIcon"));
__export(require("./CarIcon"));
__export(require("./CarPlusIcon"));
__export(require("./ChargingStationIcon"));
__export(require("./ChatIcon"));
__export(require("./CheckColorIcon"));
__export(require("./CheckIcon"));
__export(require("./CheckIllustratedIcon"));
__export(require("./ChecklistIcon"));
__export(require("./CheckSquareIcon"));
__export(require("./ChevronDownIcon"));
__export(require("./ChevronLeftIcon"));
__export(require("./ChevronRightIcon"));
__export(require("./ChevronUpIcon"));
__export(require("./ChildrenIcon"));
__export(require("./CigaretteIcon"));
__export(require("./ClipboardCheckIcon"));
__export(require("./ClipIcon"));
__export(require("./ClockIcon"));
__export(require("./CloseBorderIcon"));
__export(require("./CloseIcon"));
__export(require("./CloverleafIcon"));
__export(require("./CocktailIcon"));
__export(require("./CogwheelIcon"));
__export(require("./CommentIcon"));
__export(require("./CompassIcon"));
__export(require("./CompetitionIcon"));
__export(require("./ConnectionIcon"));
__export(require("./ConsultantIcon"));
__export(require("./ContributionIcon"));
__export(require("./CopyLinkIcon"));
__export(require("./CreditCardPencilIcon"));
__export(require("./CrossSellingIcon"));
__export(require("./CupIcon"));
__export(require("./CurrencyDollarIcon"));
__export(require("./CurrencyEuroIcon"));
__export(require("./DamageIcon"));
__export(require("./DashboardCheckIcon"));
__export(require("./DashboardHourglassIcon"));
__export(require("./DemoIcon"));
__export(require("./DentalBridgeIcon"));
__export(require("./DentalCrownIcon"));
__export(require("./DentalFillingIcon"));
__export(require("./DentalGrinderbracesIcon"));
__export(require("./DentalImplantIcon"));
__export(require("./DentalInlaysIcon"));
__export(require("./DentalLaborIcon"));
__export(require("./DentalNowIcon"));
__export(require("./DentalOnlaysIcon"));
__export(require("./DentalOrthodonticsIcon"));
__export(require("./DentalParadontosisIcon"));
__export(require("./DentalPlusIcon"));
__export(require("./DentalPlusImplantatIcon"));
__export(require("./DentalProphylaxisIcon"));
__export(require("./DentalProthesisIcon"));
__export(require("./DentalRepairIcon"));
__export(require("./DentalRetentionIcon"));
__export(require("./DentalRootTreatmentIcon"));
__export(require("./DentalSplintIcon"));
__export(require("./DentalSubstituteIcon"));
__export(require("./DentalToothCleaningIcon"));
__export(require("./DesktopPcBrokenIcon"));
__export(require("./DesktopPcIcon"));
__export(require("./DeviceIcon"));
__export(require("./DfbPokalIcon"));
__export(require("./DiamondIcon"));
__export(require("./DiceIcon"));
__export(require("./DirectionsIcon"));
__export(require("./DiscountIcon"));
__export(require("./DoctorIcon"));
__export(require("./DocumentAddIcon"));
__export(require("./DocumentAlertIcon"));
__export(require("./DocumentArrowBackIcon"));
__export(require("./DocumentChartsIcon"));
__export(require("./DocumentCheckIcon"));
__export(require("./DocumentCommentIcon"));
__export(require("./DocumentCurrencyEuroIcon"));
__export(require("./DocumentEyeIcon"));
__export(require("./DocumentGetIcon"));
__export(require("./DocumentIcon"));
__export(require("./DocumentLockedIcon"));
__export(require("./DocumentPencilIcon"));
__export(require("./DocumentPinnedIcon"));
__export(require("./DocumentQuestionIcon"));
__export(require("./DocumentSaveIcon"));
__export(require("./DocumentSigelIcon"));
__export(require("./DocumentStarAlertIcon"));
__export(require("./DocumentStarChartsIcon"));
__export(require("./DocumentStarIcon"));
__export(require("./DocumentStarLockedIcon"));
__export(require("./DocumentUploadIcon"));
__export(require("./DocumentUploadSuperIcon"));
__export(require("./DogIcon"));
__export(require("./DogLeashIcon"));
__export(require("./DogPawIcon"));
__export(require("./DotIcon"));
__export(require("./DownBorderIcon"));
__export(require("./DownloadIcon"));
__export(require("./DumbbellIcon"));
__export(require("./EbisIcon"));
__export(require("./EditIcon"));
__export(require("./EkomiStarRatingIcon"));
__export(require("./ElectricBicycleIcon"));
__export(require("./ElectronIcon"));
__export(require("./EmailIcon"));
__export(require("./EnvelopeCheckColorIcon"));
__export(require("./EnvelopeHouseIcon"));
__export(require("./EuroChartIcon"));
__export(require("./ExternalLinkIcon"));
__export(require("./EyeIcon"));
__export(require("./FacebookColorIcon"));
__export(require("./FacebookIcon"));
__export(require("./FactoryIcon"));
__export(require("./FamilyIcon"));
__export(require("./FaxIcon"));
__export(require("./FireIcon"));
__export(require("./FolderIcon"));
__export(require("./FoldersIcon"));
__export(require("./FoldersStarIcon"));
__export(require("./FootstepsIcon"));
__export(require("./ForeignCharacterIcon"));
__export(require("./ForwardDocumentIcon"));
__export(require("./ForwardOpenMessageIcon"));
__export(require("./FundsMixedFundsColorIcon"));
__export(require("./FundsPensionFundsColorIcon"));
__export(require("./FundsRegionEuropeColorIcon"));
__export(require("./FundsRegionGermanyColorIcon"));
__export(require("./FundsRegionWorldColorIcon"));
__export(require("./FundsRiskBalancedColorIcon"));
__export(require("./FundsRiskDefensiveColorIcon"));
__export(require("./FundsRiskDynamicColorIcon"));
__export(require("./FundsRiskRiskorientedColorIcon"));
__export(require("./FundsRiskStableColorIcon"));
__export(require("./FundsShareFundsColorIcon"));
__export(require("./FuneralForestIcon"));
__export(require("./FuneralIcon"));
__export(require("./FuneralSeaIcon"));
__export(require("./FuneralUrnIcon"));
__export(require("./GameControllerIcon"));
__export(require("./GasStationIcon"));
__export(require("./GermanEagleIcon"));
__export(require("./GiftIcon"));
__export(require("./GlassesIcon"));
__export(require("./GlobeIcon"));
__export(require("./GlobeStandIcon"));
__export(require("./GooglePlusIcon"));
__export(require("./GrandparentsIcon"));
__export(require("./GroupIcon"));
__export(require("./GrowthIcon"));
__export(require("./HandsChildIcon"));
__export(require("./HandsEuroIcon"));
__export(require("./HandshakeIcon"));
__export(require("./HandsLuggageIcon"));
__export(require("./HandsMoneyIcon"));
__export(require("./HeadsetIcon"));
__export(require("./HealthcareIcon"));
__export(require("./HeartbeatIcon"));
__export(require("./HeartIcon"));
__export(require("./HelicopterIcon"));
__export(require("./HelpIcon"));
__export(require("./HobbyIcon"));
__export(require("./HorizonIcon"));
__export(require("./HorseIcon"));
__export(require("./HospitalIcon"));
__export(require("./HouseGroundIcon"));
__export(require("./HouseIcon"));
__export(require("./HouseLockedIcon"));
__export(require("./HumanPlusIcon"));
__export(require("./IdCardIcon"));
__export(require("./InfoIcon"));
__export(require("./InstagramIcon"));
__export(require("./JigsawIcon"));
__export(require("./KeyIcon"));
__export(require("./KingsCrownIcon"));
__export(require("./LampBlastIcon"));
__export(require("./LaptopBlastIcon"));
__export(require("./LaptopIcon"));
__export(require("./LawIcon"));
__export(require("./LayersIcon"));
__export(require("./LeftBorderIcon"));
__export(require("./LessIcon"));
__export(require("./LiabilityIcon"));
__export(require("./LibraIcon"));
__export(require("./LightBulbIcon"));
__export(require("./LightningIcon"));
__export(require("./LinkedinColorIcon"));
__export(require("./LinkedinIcon"));
__export(require("./LoaderIcon"));
__export(require("./LoanBuildingContractIcon"));
__export(require("./LocationIcon"));
__export(require("./LockClosedIcon"));
__export(require("./LockIcon"));
__export(require("./LockOpenIcon"));
__export(require("./LoginIcon"));
__export(require("./LoginLockedIcon"));
__export(require("./LuggageIcon"));
__export(require("./MagnifierIcon"));
__export(require("./MailIcon"));
__export(require("./ManBubbleIcon"));
__export(require("./ManIcon"));
__export(require("./MediaDownloadIcon"));
__export(require("./MedicineIcon"));
__export(require("./MegaphoneIcon"));
__export(require("./MicrophoneIcon"));
__export(require("./MinusIcon"));
__export(require("./MobilePhoneIcon"));
__export(require("./MoneyBlackIcon"));
__export(require("./MoneyIcon"));
__export(require("./MoreIcon"));
__export(require("./MotorbikeIcon"));
__export(require("./MotorVehicleIcon"));
__export(require("./MountainIcon"));
__export(require("./MouseIcon"));
__export(require("./MoveDocumentIcon"));
__export(require("./NaturalHealingIcon"));
__export(require("./NetworkIcon"));
__export(require("./NewspaperIcon"));
__export(require("./NurseIcon"));
__export(require("./OfficeIcon"));
__export(require("./OrdersIcon"));
__export(require("./PagesIcon"));
__export(require("./PaletteIcon"));
__export(require("./ParentsIcon"));
__export(require("./PatchIcon"));
__export(require("./PdfIcon"));
__export(require("./PenIcon"));
__export(require("./PersonEnvelopeIcon"));
__export(require("./PhoneIcon"));
__export(require("./PhotoFlashIcon"));
__export(require("./PhotoIcon"));
__export(require("./PictureIcon"));
__export(require("./PigIcon"));
__export(require("./PlaneIcon"));
__export(require("./PlayIcon"));
__export(require("./PlugIcon"));
__export(require("./PlusIcon"));
__export(require("./PointerIcon"));
__export(require("./PointingFingerIcon"));
__export(require("./PrinterIcon"));
__export(require("./PrintIcon"));
__export(require("./ProfileAddIcon"));
__export(require("./ProfileCheckIcon"));
__export(require("./ProfileCommentIcon"));
__export(require("./ProfileDeniedIcon"));
__export(require("./ProfileDownloadIcon"));
__export(require("./ProfileIcon"));
__export(require("./ProfileMailIcon"));
__export(require("./ProfilePencilIcon"));
__export(require("./ProfileSearchIcon"));
__export(require("./ProfileUploadIcon"));
__export(require("./ProfilIcon"));
__export(require("./QueensCrownIcon"));
__export(require("./QuestionMarkIcon"));
__export(require("./QuoteIcon"));
__export(require("./RadioactiveIcon"));
__export(require("./ReachabilityPhoneIcon"));
__export(require("./RefreshIcon"));
__export(require("./RehabilitationIcon"));
__export(require("./RightBorderIcon"));
__export(require("./RiskIcon"));
__export(require("./RssIcon"));
__export(require("./SaveCheckIcon"));
__export(require("./ScissorsIcon"));
__export(require("./ScrollToTopIcon"));
__export(require("./SearchIcon"));
__export(require("./SearchPaperIcon"));
__export(require("./SectionIcon"));
__export(require("./SendIcon"));
__export(require("./ShareIcon"));
__export(require("./SharePaperIcon"));
__export(require("./ShieldIcon"));
__export(require("./ShoppingCartIcon"));
__export(require("./SinkBlastIcon"));
__export(require("./SinkIcon"));
__export(require("./SkypeIcon"));
__export(require("./SnowflakeIcon"));
__export(require("./StarFilledIcon"));
__export(require("./StarIcon"));
__export(require("./StopIcon"));
__export(require("./StoreIcon"));
__export(require("./SunGlassesCurrencyEuroIcon"));
__export(require("./SunglassesIcon"));
__export(require("./SunIcon"));
__export(require("./SupportIcon"));
__export(require("./TabletIcon"));
__export(require("./TapwaterIcon"));
__export(require("./TariffBasisIcon"));
__export(require("./TariffCheckLightIcon"));
__export(require("./TariffComfortIcon"));
__export(require("./TariffPremiumIcon"));
__export(require("./TarifIndividuellIcon"));
__export(require("./TelephoneIcon"));
__export(require("./TestTubeIcon"));
__export(require("./ThumbnailsIcon"));
__export(require("./ThumbsDownIcon"));
__export(require("./ThumbsUpIcon"));
__export(require("./ThunderstormIcon"));
__export(require("./TicketIcon"));
__export(require("./TimeBackwardsIcon"));
__export(require("./TimesIcon"));
__export(require("./TimesThinIcon"));
__export(require("./ToolsIcon"));
__export(require("./ToothIcon"));
__export(require("./TrainIcon"));
__export(require("./TrashbinIcon"));
__export(require("./TreeIcon"));
__export(require("./TripIcon"));
__export(require("./TruckIcon"));
__export(require("./TShirtIcon"));
__export(require("./TwitterColorIcon"));
__export(require("./TwitterIcon"));
__export(require("./UnlockedIcon"));
__export(require("./UpBorderIcon"));
__export(require("./VaseBlastIcon"));
__export(require("./VideoAuthenticationIcon"));
__export(require("./WashingMachineIcon"));
__export(require("./WaterIcon"));
__export(require("./WeaponIcon"));
__export(require("./WhatsappColorIcon"));
__export(require("./WhatsappIcon"));
__export(require("./WheelchairIcon"));
__export(require("./WheelIcon"));
__export(require("./WindmillIcon"));
__export(require("./WindowIcon"));
__export(require("./WindsurferIcon"));
__export(require("./WomanIcon"));
__export(require("./XingColorIcon"));
__export(require("./XingIcon"));
__export(require("./YoutubeColorIcon"));
__export(require("./YoutubeIcon"));
// Map of icon key to german name
exports.iconNameMap = {
    'AcademyIcon': 'AcademyIcon',
    'AcrobatIcon': 'AcrobatIcon',
    'AirplaneIcon': 'AirplaneIcon',
    'AlarmClockIcon': 'AlarmClockIcon',
    'AlertIcon': 'ERGO_Icon_black_Achtung1',
    'AmbulanceIcon': 'AmbulanceIcon',
    'AnalysisCoupleIcon': 'AnalysisCoupleIcon',
    'AnalysisFamilyIcon': 'AnalysisFamilyIcon',
    'AnalysisSingleIcon': 'AnalysisSingleIcon',
    'AnalysisSingleParentIcon': 'AnalysisSingleParentIcon',
    'ApartmentBuildingIcon': 'ERGO_Icon_black_Immobilien',
    'AppleIcon': 'AppleIcon',
    'ArrowDownIcon': 'ArrowDownIcon',
    'ArrowLeftIcon': 'ArrowLeftIcon',
    'ArrowRightIcon': 'ArrowRightIcon',
    'ArrowUpIcon': 'ArrowUpIcon',
    'AsteriskIcon': 'AsteriskIcon',
    'AtomIcon': 'AtomIcon',
    'AwardIcon': 'AwardIcon',
    'BadgeIcon': 'ERGO_Icon_black_Auszeichnung',
    'BarchartsIcon': 'BarchartsIcon',
    'BasketIcon': 'BasketIcon',
    'BedIcon': 'ERGO_Icon_black_Pflege:Bett',
    'BedSingleIcon': 'BedSingleIcon',
    'BeerIcon': 'ERGO_Icon_black_Bierkrug',
    'BicycleIcon': 'BicycleIcon',
    'BirthdayCakeIcon': 'ERGO_Icon_black_Torte',
    'BlastIcon': 'ERGO_Icon_black_damage',
    'BlogIcon': 'BlogIcon',
    'BlueLightIcon': 'ERGO_Icon_black_Blaulicht',
    'BoatIcon': 'ERGO_Icon_black_Boot',
    'BoneIcon': 'BoneIcon',
    'BookIcon': 'BookIcon',
    'BookmarkIcon': 'BookmarkIcon',
    'BoxBlastIcon': 'ERGO_Icon_black_removal',
    'BrokenArmIcon': 'ERGO_Icon_black_Mann_Gipsarm3',
    'BrokenArmStarIcon': 'ERGO_Icon_black_Mann_Gipsarm2',
    'BrokenLegIcon': 'ERGO_Icon_black_Fuss_Verband',
    'BulletIcon': 'BulletIcon',
    'BurgerMenuIcon': 'BurgerMenuIcon',
    'BusinessCardIcon': 'BusinessCardIcon',
    'CalculatorIcon': 'ERGO_Icon_black_Taschenrechner',
    'CalendarDateIcon': 'CalendarDateIcon',
    'CalendarIcon': 'CalendarIcon',
    'CallBackIcon': 'CallBackIcon',
    'CameraIcon': 'CameraIcon',
    'CamperIcon': 'ERGO_Icon_black_Wohnmobil',
    'CandleIcon': 'ERGO_Icon_black_Kerze',
    'CapitolIcon': 'ERGO_Icon_black_Gericht',
    'CarDamageIcon': 'ERGO_Icon_black_car_damage',
    'CarIcon': 'ERGO_Icon_black_car',
    'CarPlusIcon': 'ERGO_Icon_black_car_plus',
    'CaravanIcon': 'ERGO_Icon_black_Wohnwagen',
    'CareerIcon': 'CareerIcon',
    'CaretDownIcon': 'CaretDownIcon',
    'CaretUpIcon': 'CaretUpIcon',
    'ChargingStationIcon': 'ERGO_Icon_black_charging_station',
    'ChatIcon': 'ChatIcon',
    'CheckColorIcon': 'CheckColorIcon',
    'CheckIcon': 'CheckIcon',
    'CheckIllustratedIcon': 'CheckIllustratedIcon',
    'CheckSquareIcon': 'CheckSquareIcon',
    'ChecklistIcon': 'ERGO_Icon_black_Checkliste',
    'ChevronDownIcon': 'ChevronDownIcon',
    'ChevronLeftIcon': 'ChevronLeftIcon',
    'ChevronRightIcon': 'ChevronRightIcon',
    'ChevronUpIcon': 'ChevronUpIcon',
    'ChildrenIcon': 'ChildrenIcon',
    'CigaretteIcon': 'ERGO_Icon_black_Zigarette',
    'ClipIcon': 'ClipIcon',
    'ClipboardCheckIcon': 'ClipboardCheckIcon',
    'ClockIcon': 'ClockIcon',
    'CloseBorderIcon': 'CloseBorderIcon',
    'CloseIcon': 'CloseIcon',
    'CloverleafIcon': 'CloverleafIcon',
    'CocktailIcon': 'ERGO_Icon_black_Coctail',
    'CogwheelIcon': 'CogwheelIcon',
    'CommentIcon': 'CommentIcon',
    'CompassIcon': 'ERGO_Icon_black_Kompass',
    'CompetitionIcon': 'CompetitionIcon',
    'ConnectionIcon': 'ConnectionIcon',
    'ConsultantIcon': 'ConsultantIcon',
    'ContributionIcon': 'ERGO_Icon_black_contribution',
    'CopyLinkIcon': 'CopyLinkIcon',
    'CreditCardPencilIcon': 'CreditCardPencilIcon',
    'CrossSellingIcon': 'ERGO_Icon_black_Crosselling',
    'CupIcon': 'CupIcon',
    'CurrencyDollarIcon': 'CurrencyDollarIcon',
    'CurrencyEuroIcon': 'ERGO_Icon_black_contribution',
    'DamageIcon': 'DamageIcon',
    'DashboardCheckIcon': 'DashboardCheckIcon',
    'DashboardHourglassIcon': 'DashboardHourglassIcon',
    'DemoIcon': 'DemoIcon',
    'DentalBridgeIcon': 'DentalBridgeIcon',
    'DentalCrownIcon': 'DentalCrownIcon',
    'DentalFillingIcon': 'DentalFillingIcon',
    'DentalGrinderbracesIcon': 'DentalGrinderbracesIcon',
    'DentalImplantIcon': 'DentalImplantIcon',
    'DentalInlaysIcon': 'DentalInlaysIcon',
    'DentalLaborIcon': 'DentalLaborIcon',
    'DentalNowIcon': 'DentalNowIcon',
    'DentalOnlaysIcon': 'DentalOnlaysIcon',
    'DentalOrthodonticsIcon': 'ERGO_Icon_black_Kieferorthopädie',
    'DentalParadontosisIcon': 'DentalParadontosisIcon',
    'DentalPlusIcon': 'DentalPlusIcon',
    'DentalPlusImplantatIcon': 'DentalPlusImplantatIcon',
    'DentalProphylaxisIcon': 'DentalProphylaxisIcon',
    'DentalProthesisIcon': 'DentalProthesisIcon',
    'DentalRepairIcon': 'DentalRepairIcon',
    'DentalRetentionIcon': 'DentalRetentionIcon',
    'DentalRootTreatmentIcon': 'DentalRootTreatmentIcon',
    'DentalSplintIcon': 'DentalSplintIcon',
    'DentalSubstituteIcon': 'DentalSubstituteIcon',
    'DentalToothCleaningIcon': 'DentalToothCleaningIcon',
    'DesktopPcBrokenIcon': 'ERGO_Icon_black_Überspannung_durch_Blitz',
    'DesktopPcIcon': 'DesktopPcIcon',
    'DeviceIcon': 'DeviceIcon',
    'DfbPokalIcon': 'DfbPokalIcon',
    'DiamondIcon': 'DiamondIcon',
    'DiceIcon': 'DiceIcon',
    'DirectionsIcon': 'DirectionsIcon',
    'DogIcon': 'ERGO_Icon_black_Hund:Hundehalter',
    'DiscountIcon': 'ERGO_Icon_black_Prozent',
    'DoctorIcon': 'DoctorIcon',
    'DocumentAddIcon': 'DocumentAddIcon',
    'DocumentAlertIcon': 'DocumentAlertIcon',
    'DocumentArrowBackIcon': 'DocumentArrowBackIcon',
    'DocumentChartsIcon': 'DocumentChartsIcon',
    'DocumentCheckIcon': 'DocumentCheckIcon',
    'DocumentCommentIcon': 'DocumentCommentIcon',
    'DocumentCurrencyEuroIcon': 'ERGO_Icon_black_Rechnung',
    'DocumentEyeIcon': 'DocumentEyeIcon',
    'DocumentGetIcon': 'DocumentGetIcon',
    'DocumentIcon': 'DocumentIcon',
    'DocumentLockedIcon': 'DocumentLockedIcon',
    'DocumentPencilIcon': 'DocumentPencilIcon',
    'DocumentPinnedIcon': 'DocumentPinnedIcon',
    'DocumentQuestionIcon': 'DocumentQuestionIcon',
    'DocumentSaveIcon': 'DocumentSaveIcon',
    'DocumentSigelIcon': 'DocumentSigelIcon',
    'DocumentStarAlertIcon': 'DocumentStarAlertIcon',
    'DocumentStarChartsIcon': 'DocumentStarChartsIcon',
    'DocumentStarIcon': 'ERGO_Icon_black_Dokument3',
    'DocumentStarLockedIcon': 'DocumentStarLockedIcon',
    'DocumentUploadIcon': 'DocumentUploadIcon',
    'DocumentUploadSuperIcon': 'DocumentUploadSuperIcon',
    'DogLeashIcon': 'DogLeashIcon',
    'DogPawIcon': 'ERGO_Icon_black_Tierpfote',
    'DotIcon': 'DotIcon',
    'DownBorderIcon': 'DownBorderIcon',
    'DownloadIcon': 'DownloadIcon',
    'DumbbellIcon': 'ERGO_Icon_black_Hantel',
    'EbisIcon': 'EbisIcon',
    'EditIcon': 'EditIcon',
    'EkomiStarRatingIcon': 'EkomiStarRatingIcon',
    'ElectricBicycleIcon': 'ElectricBicycleIcon',
    'ElectronIcon': 'ElectronIcon',
    'EmailIcon': 'ERGO_Icon_black_at_Zeichen',
    'EnvelopeCheckColorIcon': 'EnvelopeCheckColorIcon',
    'EnvelopeHouseIcon': 'EnvelopeHouseIcon',
    'EuroChartIcon': 'ERGO_Icon_black_Diagramm6',
    'ExternalLinkIcon': 'ERGO_Icon_black_Link_rgb_',
    'EyeIcon': 'EyeIcon',
    'FacebookColorIcon': 'FacebookColorIcon',
    'FacebookIcon': 'FacebookIcon',
    'FactoryIcon': 'ERGO_Icon_black_Fabrik',
    'FamilyIcon': 'FamilyIcon',
    'FaxIcon': 'FaxIcon',
    'FireIcon': 'ERGO_Icon_black_Feuer',
    'FolderIcon': 'FolderIcon',
    'FoldersIcon': 'FoldersIcon',
    'FoldersStarIcon': 'FoldersStarIcon',
    'FootstepsIcon': 'ERGO_Icon_black_Schuhe_Fußabdruecke',
    'ForeignCharacterIcon': 'ForeignCharacterIcon',
    'ForwardDocumentIcon': 'ForwardDocumentIcon',
    'ForwardOpenMessageIcon': 'ForwardOpenMessageIcon',
    'FundsMixedFundsColorIcon': 'FundsMixedFundsColorIcon',
    'FundsPensionFundsColorIcon': 'FundsPensionFundsColorIcon',
    'FundsRegionEuropeColorIcon': 'FundsRegionEuropeColorIcon',
    'FundsRegionGermanyColorIcon': 'FundsRegionGermanyColorIcon',
    'FundsRegionWorldColorIcon': 'FundsRegionWorldColorIcon',
    'FundsRiskBalancedColorIcon': 'FundsRiskBalancedColorIcon',
    'FundsRiskDefensiveColorIcon': 'FundsRiskDefensiveColorIcon',
    'FundsRiskDynamicColorIcon': 'FundsRiskDynamicColorIcon',
    'FundsRiskRiskorientedColorIcon': 'FundsRiskRiskorientedColorIcon',
    'FundsRiskStableColorIcon': 'FundsRiskStableColorIcon',
    'FundsShareFundsColorIcon': 'FundsShareFundsColorIcon',
    'FuneralForestIcon': 'FuneralForestIcon',
    'FuneralIcon': 'FuneralIcon',
    'FuneralSeaIcon': 'FuneralSeaIcon',
    'FuneralUrnIcon': 'FuneralUrnIcon',
    'GameControllerIcon': 'GameControllerIcon',
    'GasStationIcon': 'GasStationIcon',
    'GermanEagleIcon': 'ERGO_Icon_black_Staat_Adler',
    'GiftIcon': 'GiftIcon',
    'GlassesIcon': 'ERGO_Icon_black_Brille',
    'GlobeIcon': 'GlobeIcon',
    'GlobeStandIcon': 'ERGO_Icon_black_globe',
    'GooglePlusIcon': 'GooglePlusIcon',
    'GrandparentsIcon': 'ERGO_Icon_black_senior',
    'GroupIcon': 'GroupIcon',
    'GrowthIcon': 'GrowthIcon',
    'HandsChildIcon': 'ERGO_Icon_black_Haende2',
    'HandsEuroIcon': 'HandsEuroIcon',
    'HandsMoneyIcon': 'ERGO_Icon_black_Hand6',
    'HeadsetIcon': 'ERGO_Icon_black_Headset',
    'HeartIcon': 'HeartIcon',
    'HelicopterIcon': 'ERGO_Icon_black_Hubschrauber',
    'HobbyIcon': 'HobbyIcon',
    'HorseIcon': 'ERGO_Icon_black_Pferd:Pferdehalter',
    'HouseGroundIcon': 'HouseGroundIcon',
    'HouseLockedIcon': 'HouseLockedIcon',
    'IdCardIcon': 'IdCardIcon',
    'InstagramIcon': 'InstagramIcon',
    'KeyIcon': 'ERGO_Icon_black_key',
    'LampBlastIcon': 'LampBlastIcon',
    'LaptopIcon': 'LaptopIcon',
    'LayersIcon': 'LayersIcon',
    'LessIcon': 'LessIcon',
    'LibraIcon': 'ERGO_Icon_black_Gesetz_Waage',
    'LightningIcon': 'ERGO_Icon_black_lightning',
    'HandsLuggageIcon': 'ERGO_Icon_black_Haende5',
    'HandshakeIcon': 'HandshakeIcon',
    'HealthcareIcon': 'HealthcareIcon',
    'HeartbeatIcon': 'ERGO_Icon_black_Krankheit',
    'HelpIcon': 'HelpIcon',
    'HorizonIcon': 'HorizonIcon',
    'HospitalIcon': 'ERGO_Icon_black_Krankenhaus:Geld',
    'HouseIcon': 'HouseIcon',
    'HumanPlusIcon': 'HumanPlusIcon',
    'InfoIcon': 'InfoIcon',
    'JigsawIcon': 'JigsawIcon',
    'KingsCrownIcon': 'KingsCrownIcon',
    'LaptopBlastIcon': 'LaptopBlastIcon',
    'LawIcon': 'LawIcon',
    'LeftBorderIcon': 'LeftBorderIcon',
    'LiabilityIcon': 'LiabilityIcon',
    'LightBulbIcon': 'ERGO_Icon_black_Glühbirne',
    'LockIcon': 'ERGO_Icon_black_Schloss',
    'TwitterIcon': 'TwitterIcon',
    'UnlockedIcon': 'UnlockedIcon',
    'UpBorderIcon': 'UpBorderIcon',
    'VaseBlastIcon': 'ERGO_Icon_black_Haftpflicht',
    'VideoAuthenticationIcon': 'VideoAuthenticationIcon',
    'WashingMachineIcon': 'ERGO_Icon_black_Spülmaschine',
    'WaterIcon': 'ERGO_Icon_black_Wasser',
    'WeaponIcon': 'ERGO_Icon_black_Pistole',
    'WhatsappColorIcon': 'WhatsappColorIcon',
    'WhatsappIcon': 'WhatsappIcon',
    'WheelIcon': 'WheelIcon',
    'WheelchairIcon': 'ERGO_Icon_black_Rollstuhl',
    'WindmillIcon': 'ERGO_Icon_black_Windrad',
    'WindowIcon': 'ERGO_Icon_black_Fenster_Glas',
    'WindsurferIcon': 'WindsurferIcon',
    'WomanIcon': 'WomanIcon',
    'XingColorIcon': 'XingColorIcon',
    'XingIcon': 'XingIcon',
    'YoutubeColorIcon': 'YoutubeColorIcon',
    'YoutubeIcon': 'YoutubeIcon',
    'SinkBlastIcon': 'SinkBlastIcon',
    'SkypeIcon': 'SkypeIcon',
    'StarFilledIcon': 'StarFilledIcon',
    'StoreIcon': 'ERGO_Icon_black_Google_my_business',
    'SunIcon': 'SunIcon',
    'SunglassesIcon': 'SunglassesIcon',
    'TShirtIcon': 'TShirtIcon',
    'TapwaterIcon': 'ERGO_Icon_black_tapwater',
    'TariffBasisIcon': 'TariffBasisIcon',
    'TariffComfortIcon': 'TariffComfortIcon',
    'TelephoneIcon': 'TelephoneIcon',
    'ThumbnailsIcon': 'ThumbnailsIcon',
    'ThumbsUpIcon': 'ERGO_Icon_black_Daumen_hoch',
    'TicketIcon': 'ERGO_Icon_black_Ticket',
    'TimesIcon': 'TimesIcon',
    'ToolsIcon': 'ERGO_Icon_black_tool',
    'TrainIcon': 'TrainIcon',
    'TreeIcon': 'TreeIcon',
    'TripIcon': 'ERGO_Icon_black_Reise',
    'TwitterColorIcon': 'TwitterColorIcon',
    'LinkedinColorIcon': 'LinkedinColorIcon',
    'LinkedinIcon': 'LinkedinIcon',
    'LoaderIcon': 'LoaderIcon',
    'LoanBuildingContractIcon': 'LoanBuildingContractIcon',
    'LocationIcon': 'LocationIcon',
    'LockClosedIcon': 'LockClosedIcon',
    'LockOpenIcon': 'LockOpenIcon',
    'LoginIcon': 'LoginIcon',
    'LoginLockedIcon': 'LoginLockedIcon',
    'LuggageIcon': 'LuggageIcon',
    'MagnifierIcon': 'MagnifierIcon',
    'MailIcon': 'MailIcon',
    'ManBubbleIcon': 'ManBubbleIcon',
    'ManIcon': 'ManIcon',
    'MediaDownloadIcon': 'MediaDownloadIcon',
    'MedicineIcon': 'ERGO_Icon_black_Eigenanteil_Medikamente',
    'MegaphoneIcon': 'MegaphoneIcon',
    'MicrophoneIcon': 'MicrophoneIcon',
    'MinusIcon': 'MinusIcon',
    'MobilePhoneIcon': 'ERGO_Icon_black_Smartphone',
    'MoneyBlackIcon': 'MoneyBlackIcon',
    'MoneyIcon': 'MoneyIcon',
    'MoreIcon': 'MoreIcon',
    'MotorVehicleIcon': 'MotorVehicleIcon',
    'MotorbikeIcon': 'ERGO_Icon_black_Motorrad',
    'MountainIcon': 'ERGO_Icon_black_Berg_Wolke',
    'MouseIcon': 'ERGO_Icon_black_Computermaus',
    'MoveDocumentIcon': 'MoveDocumentIcon',
    'NaturalHealingIcon': 'ERGO_Icon_black_Naturheilverfahren',
    'NetworkIcon': 'NetworkIcon',
    'NewspaperIcon': 'ERGO_Icon_black_Zeitung',
    'NurseIcon': 'ERGO_Icon_black_Krankenschwester',
    'OfficeIcon': 'ERGO_Icon_black_Buerogebaeude',
    'OrdersIcon': 'OrdersIcon',
    'PagesIcon': 'PagesIcon',
    'PaletteIcon': 'PaletteIcon',
    'ParentsIcon': 'ERGO_Icon_black_couple',
    'PatchIcon': 'ERGO_Icon_black_Pflaster',
    'PdfIcon': 'PdfIcon',
    'PenIcon': 'ERGO_Icon_black_Fueller',
    'PersonEnvelopeIcon': 'PersonEnvelopeIcon',
    'PhoneIcon': 'PhoneIcon',
    'PhotoFlashIcon': 'PhotoFlashIcon',
    'PhotoIcon': 'PhotoIcon',
    'PictureIcon': 'PictureIcon',
    'PigIcon': 'ERGO_Icon_black_Sparschwein',
    'PlaneIcon': 'PlaneIcon',
    'PlayIcon': 'PlayIcon',
    'PlugIcon': 'ERGO_Icon_black_Stecker',
    'PlusIcon': 'PlusIcon',
    'PointerIcon': 'PointerIcon',
    'PointingFingerIcon': 'PointingFingerIcon',
    'PrintIcon': 'PrintIcon',
    'PrinterIcon': 'PrinterIcon',
    'ProfilIcon': 'ProfilIcon',
    'ProfileAddIcon': 'ProfileAddIcon',
    'ProfileCheckIcon': 'ProfileCheckIcon',
    'ProfileCommentIcon': 'ProfileCommentIcon',
    'ProfileDeniedIcon': 'ProfileDeniedIcon',
    'ProfileDownloadIcon': 'ProfileDownloadIcon',
    'ProfileIcon': 'ProfileIcon',
    'ProfileMailIcon': 'ProfileMailIcon',
    'ProfilePencilIcon': 'ProfilePencilIcon',
    'ProfileSearchIcon': 'ProfileSearchIcon',
    'ProfileUploadIcon': 'ProfileUploadIcon',
    'QueensCrownIcon': 'QueensCrownIcon',
    'QuestionMarkIcon': 'QuestionMarkIcon',
    'QuoteIcon': 'QuoteIcon',
    'RadioactiveIcon': 'RadioactiveIcon',
    'ReachabilityPhoneIcon': 'ReachabilityPhoneIcon',
    'RefreshIcon': 'RefreshIcon',
    'RehabilitationIcon': 'ERGO_Icon_black_Reha_Maßnahmen',
    'RightBorderIcon': 'RightBorderIcon',
    'RiskIcon': 'RiskIcon',
    'RssIcon': 'RssIcon',
    'SaveCheckIcon': 'SaveCheckIcon',
    'ScissorsIcon': 'ScissorsIcon',
    'ScrollToTopIcon': 'ScrollToTopIcon',
    'SearchIcon': 'SearchIcon',
    'SearchPaperIcon': 'SearchPaperIcon',
    'SectionIcon': 'SectionIcon',
    'SendIcon': 'SendIcon',
    'ShareIcon': 'ShareIcon',
    'SharePaperIcon': 'SharePaperIcon',
    'ShieldIcon': 'ERGO_Icon_black_Schutzschild3',
    'ShoppingCartIcon': 'ERGO_Icon_black_Einkaufswagen',
    'SinkIcon': 'SinkIcon',
    'SnowflakeIcon': 'ERGO_Icon_black_Schneeflocke',
    'StarIcon': 'StarIcon',
    'StopIcon': 'StopIcon',
    'SunGlassesCurrencyEuroIcon': 'SunGlassesCurrencyEuroIcon',
    'SupportIcon': 'SupportIcon',
    'TabletIcon': 'ERGO_Icon_black_iPad',
    'TarifIndividuellIcon': 'TarifIndividuellIcon',
    'TariffCheckLightIcon': 'TariffCheckLightIcon',
    'TariffPremiumIcon': 'TariffPremiumIcon',
    'TestTubeIcon': 'TestTubeIcon',
    'ThumbsDownIcon': 'ERGO_Icon_black_Daumen_hoch',
    'ThunderstormIcon': 'ThunderstormIcon',
    'TimeBackwardsIcon': 'TimeBackwardsIcon',
    'TimesThinIcon': 'TimesThinIcon',
    'ToothIcon': 'ToothIcon',
    'TrashbinIcon': 'TrashbinIcon',
    'TruckIcon': 'ERGO_Icon_black_Lkw',
};
//# sourceMappingURL=index.js.map